module.exports = __webpack_public_path__ + "img/titlePc22-safeimagekit.eda2e67e.png";